module.exports = __webpack_public_path__ + "assets/img/recordIcon7.30003c13.png";